const BASE_URL = process.env.baseUrl;
const AWS_BASE_URL = process.env.awsBaseUrl;
export const API_URL = `${BASE_URL}/api/seeker/jobbasket`;
export const REGISTER_SMART_ALERTS = `${BASE_URL}/api/registersmartalerts/register`;
export const UPDATE_SMART_ALERTS = `${BASE_URL}/api/updatesmartalerts`;
export const UPDATE_SMART_ALERTS_DATA = `${BASE_URL}/api/updatesmartalerts/data`;
export const ACTIVATE_SMART_ALERTS = `${BASE_URL}/api/updatesmartalerts/activatesmartalerts`;
export const SMART_ALERTS_ACTIVATE = `${BASE_URL}/api/updatesmartalerts/activate`;
export const SMART_ALERTS_REMOVE = `${BASE_URL}/api/updatesmartalerts/remove`;
export const SMART_ALERTS_REMOVE_DATA = `${BASE_URL}/api/updatesmartalerts/removedata`;
export const COMPANY = `${BASE_URL}/api/company`;
export const RESET_PASSWORD = `${BASE_URL}/api/seeker/resetpassword`;
export const UPLOAD_CV = `${BASE_URL}/api/seeker/uploadcv`;
export const WATCH_CV = `${BASE_URL}/api/seeker/watchcv`;
export const UPDATE_CV = `${BASE_URL}/api/seeker/updatecv`;
export const DELETE_CV = `${BASE_URL}/api/seeker/deletecv`;
export const SEND_SINGLE_CV = `${BASE_URL}/api/cv/sendsinglecv`;
export const UPDATE_PROFILE = `${BASE_URL}/api/seeker/updateprofile`;
export const UPDATE_EMAIL = `${BASE_URL}/api/seeker/updateemail`;
export const UPDATE_PASSWORD = `${BASE_URL}/api/seeker/updatepassword`;
export const SET_PASSWORD = `${BASE_URL}/api/seeker/setpassword`;
export const SEND_CV_EXTERNAL = `${BASE_URL}/api/statistics/sendcvexternal`;
export const SEND_MULTIPLE_CV = `${BASE_URL}/api/cv/sendmultiplecv`;
export const UPDATE_FLAGS = `${BASE_URL}/api/seeker/updateflags`;
export const SIGN_UP = `${BASE_URL}/api/authentication/signup`;

export const CONTACT_US_FEEDBACK = `${BASE_URL}/api/contactus/feedback`;
export const VERIFY_EMAIL = `${BASE_URL}/api/authentication/verifyemail/get`;
export const IS_EMAIL_EXISTS = `${BASE_URL}/api/authentication/IsEmailExists/get`;
export const CITY_AUTO_COMPLETE = `${BASE_URL}/api/cities/autocomplete`;
export const SMART_AGENT_FEEDBACK = `${BASE_URL}/api/contactus/smartagentfeedback`;
export const DELETE_AGENT = `${BASE_URL}/api/updatesmartalerts/delete`;
export const HOT_JOB_CLICK = `${BASE_URL}/api/statistics/hotjobclick`;
export const STATISTICS_JOB_CLICK = `${BASE_URL}/api/statistics/jobclick`;
export const STATISTICS_SEND_CV_EXTERNAL = `${BASE_URL}/api/statistics/sendcvexternal`;
export const STATISTICS_JOB_VIEW = `${BASE_URL}/api/statistics/jobview`;
export const STATISTICS_CSV = `${BASE_URL}/api/statistics/csv`;
export const STATISTICS_PIRSUM = `${BASE_URL}/api/statistics/pirsumstat`;
export const STATISTICS_BANNER = `${BASE_URL}/api/statistics/bannerstat`;
export const UPDATE_JOBS = `${BASE_URL}/api/jobs/update`;
export const ADMIN_REDIRECT = `${BASE_URL}/api/admin/redirect`;
export const DIVUR_REDIRECT = `${BASE_URL}/api/home/get`;
export const UNSUBSCRIBE_CV_SUMMARY = `${BASE_URL}/api/unsubscribe/cvsummary`;
export const UNSUBSCRIBE_CV_SUMMARY_REMOVE = `${BASE_URL}/api/unsubscribe/cvsummaryremove`;
export const UNSUBSCRIBE_PROMOTIONS = `${BASE_URL}/api/unsubscribe/promotions`;
export const UNSUBSCRIBE_PROMOTIONS_REMOVE = `${BASE_URL}/api/unsubscribe/promotionsremove`;

/******************************************* AWS ***********************************************/

// export const CONTACT_US_SUBMIT = `${BASE_URL}/api/contactus/submit`;
export const CONTACT_US_SUBMIT = `${AWS_BASE_URL}/contact-us/contact-us-proxy`;

// SEO
export const SEO = `${AWS_BASE_URL}/seo`;
export const ARTICLES_CATEGORIES_SEO = `${AWS_BASE_URL}/seo/articles/categories/`;

// ARTICLES
export const ARTICLES = `${AWS_BASE_URL}/articles`;
export const ARTICLES_LOBBY = `${AWS_BASE_URL}/articles/lobby`;
export const ARTICLES_CATEGORIES = `${AWS_BASE_URL}/articles/categories/`;
export const MENTORS_ARTICLES = `${AWS_BASE_URL}/articles/categories/10`;

// CATEGORIES
export const CATEGORIES = `${AWS_BASE_URL}/categories`;
export const SUB_CATEGORIES = `${AWS_BASE_URL}/categories?subcategories=true`;
export const HITECH_CATEGORY = `${AWS_BASE_URL}/categories?subcategories=true&group=hitech`;

/**********************************************************************************************/

export const CALCULATOR_DATA = `${BASE_URL}/api/calculator/data`;
export const URL_LOBBY = `${BASE_URL}/api/company/lobby`;
export const URL_SEARCH = `${BASE_URL}/api/company/search`;
export const JOB = `${BASE_URL}/api/jobs/job`;
export const JOB_PREVIEW = `${BASE_URL}/api/jobs/preview`;
export const JOB_SEARCH = `${BASE_URL}/api/jobs/search`;
export const JOB_SEARCH_SSA = `${BASE_URL}/api/jobs/searchssa`;
export const CV = `${BASE_URL}/api/seeker/cv`;
export const CV_HISTORY = `${BASE_URL}/api/seeker/cvHistory`;
export const BOARD = `${BASE_URL}/api/seeker/board`;

export const MEASURE_DATA = `${BASE_URL}/api/measure/data`;
export const MEASURE_CATEGORY_DEMAND = `${BASE_URL}/api/measure/categorydemand`;
export const WIZARD_CV_DATA = `${BASE_URL}/api/wizardcv/data`;
export const EDIT_JOB_BASKET = `${BASE_URL}/api/seeker/editjobbasket`;
export const USERAGENTS = `${BASE_URL}/api/updatesmartalerts/useragents`;
export const REGISTER_JAPU = `${BASE_URL}/api/registersmartalerts/japu`;

export const RECAPTCHA_VALIDATE_TOKEN = `${BASE_URL}/api/recaptcha3/validatetoken`;

export const KEY_FLAGS = `${BASE_URL}/api/admin/getkeys`;

// OTP Phone verification (old - not in use)
export const SEND_OTP = `${BASE_URL}/api/phoneValidation/sendotp`;
export const AUTHENTICATE_OTP = `${BASE_URL}/api/phoneValidation/authenticateotp`;

// OTP - Email verification
export const SEND_EMAIL_OTP = `${BASE_URL}/api/emailValidation/sendotp`;
export const AUTHENTICATE_EMAIL_OTP = `${BASE_URL}/api/emailValidation/authenticateotp`;
export const USER_DATA = `${BASE_URL}/api/seeker/userdata`;

export async function axiomLog(axios, path, request, error) {
  if (process.server) {
    const headers = {
      Authorization: 'Bearer xaat-3cce7b9a-73a1-47fa-9d9b-aec3911d1f2c',
      'Content-Type': 'application/json'
    };
    const axioBody = [
      {
        axiom: `y2_drushim_frontend - ${path}`,
        page: request.headers,
        error: { message: error }
      }
    ];
    await axios.post(
      'https://api.axiom.co/v1/datasets/drushim-access-logs/ingest',
      axioBody,
      { headers: headers }
    );
  }
}
